module.exports = __webpack_public_path__ + "static/media/6. El ayer 2, Resina, rama de árbol y lino sobre madera, 122 x 94cm, 2019 copy.c23e5932.png";